import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/icons/arrows/arr-gray-left.svg';
import _imports_1 from '@/assets/icons/actions/ico-btn-ulozit.svg';
const _hoisted_1 = { class: "side-box__header d-flex justify-content-between align-items-center" };
const _hoisted_2 = { class: "atom-back__inner d-flex align-items-center" };
const _hoisted_3 = { class: "d-flex gap-2" };
const _hoisted_4 = { class: "side-box__title" };
const _hoisted_5 = { class: "side-box__content w-100" };
import ErrorModal from "@/components/confirmations/error.vue";
import { useStore } from "vuex";
import { client } from "@/main";
import { computed, ref, watch } from "vue";
import UdpDeviceFormFields from "@/components/devices/udp/UdpDeviceFormFields.vue";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UdpDeviceFormModal',
    props: {
        editedDevice: {},
        isOpened: { type: Boolean },
        readOnly: { type: Boolean }
    },
    emits: ["change", "close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const { t: $t } = useI18n();
        const isErrorOpened = ref(false);
        const errors = ref([]);
        const selectedState = ref("");
        const selectedService = ref(null);
        const device = ref(props.editedDevice);
        watch(() => props.editedDevice, (value) => {
            device.value = { ...value };
        }, { immediate: true });
        const isFormValid = computed(() => {
            return device.value?.name && device.value?.serviceId;
        });
        async function handleSave() {
            errors.value = [];
            store.commit("modals/setWaitingLoader", $t("Ukládám data, čekejte prosím..."));
            await editDevice();
            await setStatus();
            await setDeviceGroups();
            await setTags();
            await setService();
            await setAttributes();
            if (errors.value.length) {
                isErrorOpened.value = true;
            }
            else {
                const notification = [
                    {
                        text: "DEVICE_SAVED",
                        error: false,
                        params: {
                            deviceName: device.value.name
                        }
                    }
                ];
                store.commit("modals/setGlobalNotification", notification);
            }
            emit("change");
            emit("close");
            store.commit("modals/setWaitingLoader", "");
        }
        async function editDevice() {
            try {
                await client.path("/udp/devices/{id}").method("put").create()({
                    id: device.value.deviceId,
                    ...device.value
                });
            }
            catch (e) {
                errors.value = e.data.errors;
            }
        }
        async function setStatus() {
            if (selectedState.value === "") {
                return;
            }
            let action;
            if (["A", "P"].includes(selectedState.value)) {
                action = "enable";
                if (device.value.status === "preregistration" && device.value.enabled) {
                    action = "activate";
                }
                try {
                    await client.path(`/udp/devices/{id}/${action}`).method("post").create()({ id: device.value.deviceId });
                    device.value.enabled = true;
                }
                catch (e) {
                    errors.value = errors.value.concat(e.data.errors);
                }
            }
            if (selectedState.value === "S") {
                try {
                    await client.path(`/udp/devices/{id}/enable`).method("delete").create()({ id: device.value.deviceId });
                    device.value.enabled = false;
                }
                catch (e) {
                    errors.value = errors.value.concat(e.data.errors);
                }
            }
        }
        async function setDeviceGroups() {
            const selectedIds = device.value.deviceGroups?.map((group) => group.deviceGroupId);
            const previousIds = props.editedDevice.deviceGroups?.map((group) => group.deviceGroupId);
            for (const group of props.editedDevice.deviceGroups ?? []) {
                if (selectedIds?.includes(group.deviceGroupId)) {
                    continue;
                }
                try {
                    await client.path("/device-groups/{id}/devices/{protocol}/{deviceId}/assign").method("delete").create()({
                        id: group.deviceGroupId,
                        deviceId: device.value.deviceId,
                        protocol: "udp"
                    });
                }
                catch (e) {
                    errors.value = errors.value.concat(e.data.errors);
                }
            }
            for (const group of device.value.deviceGroups ?? []) {
                if (previousIds?.includes(group.deviceGroupId)) {
                    continue;
                }
                try {
                    await client.path("/device-groups/{id}/devices/{protocol}/{deviceId}/assign").method("post").create()({
                        id: group.deviceGroupId,
                        deviceId: device.value.deviceId,
                        protocol: "udp"
                    });
                }
                catch (e) {
                    errors.value = errors.value.concat(e.data.errors);
                }
            }
            return true;
        }
        async function setTags() {
            if (!device.value.deviceId) {
                return;
            }
            try {
                await client
                    .path(`/udp/devices/${device.value.deviceId}/tags`)
                    .method("put")
                    .create()(device.value.tags);
            }
            catch (e) {
                errors.value = errors.value.concat(e.data.errors);
            }
        }
        async function setService() {
            if (!selectedService.value?.custServiceId ||
                !device.value.deviceId ||
                selectedService.value?.custServiceId === props.editedDevice.serviceId) {
                return;
            }
            try {
                await client.path("/services/{id}/devices/{protocol}/{deviceId}/assign").method("post").create()({
                    id: selectedService.value.custServiceId,
                    deviceId: device.value.deviceId,
                    protocol: "udp"
                });
                device.value.serviceId = selectedService.value.custServiceId;
            }
            catch (e) {
                errors.value = errors.value.concat(e.data.errors);
            }
        }
        async function setAttributes() {
            if (!device.value?.deviceId || !device.value.attributes) {
                return;
            }
            try {
                await client.path("/udp/devices/{id}/attributes").method("put").create()({
                    id: device.value.deviceId,
                    ...device.value.attributes
                });
            }
            catch (e) {
                errors.value = errors.value.concat(e.data.errors);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([{ active: _ctx.isOpened }, "side-box"])
            }, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "side-box__overlay" }, null, -1)),
                _createElementVNode("div", {
                    class: _normalizeClass([{
                            opened: _ctx.isOpened,
                            'last-active': true
                        }, "side-box__inner"]),
                    style: _normalizeStyle([_ctx.isOpened ? '' : 'right: -1500px', { "width": "800px" }])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                            class: "atom-back atom-back--gray",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                                _createElementVNode("span", null, _toDisplayString(_unref($t)("zpet")), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            (!_ctx.readOnly)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: _normalizeClass([isFormValid.value ? '' : 'disabled', "btn btn-primary primary-shadow"]),
                                    onClick: handleSave
                                }, [
                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "atom-icon" }, [
                                        _createElementVNode("img", { src: _imports_1 })
                                    ], -1)),
                                    _createElementVNode("span", null, _toDisplayString(_unref($t)("ulozitZarizeni")), 1)
                                ], 2))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("h2", null, _toDisplayString(device.value.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(UdpDeviceFormFields, {
                            "model-value": { device: device.value, selectedState: selectedState.value, selectedService: selectedService.value },
                            "read-only": _ctx.readOnly,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] =
                                (value) => {
                                    device.value = value.device;
                                    selectedState.value = value.selectedState;
                                    selectedService.value = value.selectedService;
                                })
                        }, null, 8, ["model-value", "read-only"])
                    ])
                ], 6),
                _createVNode(ErrorModal, {
                    centered: true,
                    errors: errors.value,
                    opened: isErrorOpened.value,
                    onClose: _cache[2] || (_cache[2] = ($event) => (isErrorOpened.value = false))
                }, null, 8, ["errors", "opened"])
            ], 2));
        };
    }
});
